import { type EditorProps } from "@tiptap/pm/view";
import { cx } from "shared/utils";
import type { AutoExpandConfig } from "./types/editor";

interface TArgs {
  editorClassName: string;
  autoExpandConfig?: AutoExpandConfig;
}

export const CoreEditorProps = (props: TArgs): EditorProps => {
  const { editorClassName, autoExpandConfig } = props;

  return {
    attributes: {
      class: cx("max-w-full", editorClassName)
    },
    handleDOMEvents: {
      keydown: (view, event) => {
        if (["ArrowUp", "ArrowDown", "Enter"].includes(event.key)) {
          const slashCommand = document.querySelector("#slash-command");
          if (slashCommand) return true;
        }

        if (event.key === "Enter") {
          if (
            autoExpandConfig?.collapseOnEnter &&
            !event.shiftKey &&
            autoExpandConfig.preventNewlines
          ) {
            event.preventDefault();
            autoExpandConfig.onCollapseByEnter?.();
            return true;
          }

          if (autoExpandConfig?.allowMultiline === false && !event.shiftKey) {
            event.preventDefault();
            return true;
          }

          if (autoExpandConfig?.allowMultiline === true) return false;
        }
      }
    },
    transformPastedHTML(html) {
      return html;
    }
  };
};
